export default __webpack_public_path__ + "static/media/category_t.1ec165e3.svg";